export interface CartInt {
  bagsTotal: number;
  bagsTotalAmount: number;
  bagsDetail: any[];
  totalAmount: number;
  items: CartItemsInt[];
  seatsTotal: number;
  seatsTotalAmount: number;
  seatsDetail: any[];
  currencyCode?: string;
  bagInsuranceTotal?: number;
  bagInsuranceTotalAmount?: number;
  bagInsuranceDetail?: {
    nameRefNumber: string;
    displayName?: string;
    amount: number;
    currencyCode: string;
  }[];
}

export interface CartItemsInt {
  title: string;
  quantity?: number;
  subtotal: number;
  currencyCode: string;
  detail: any[];
  typeAncillarie: TypeAncillaries;
}

export enum SourceFlowCartType {
  BAGS = 'bags',
  SEATS = 'seats',
  CARRY_ON = 'carryOn',
  EXTRA_WEIGHT = 'extraWeight',
  MANAGE_EXTRAS = 'manageExtras',
  UPGRADE = 'upgrade',
}

export type CartActions = 'add' | 'delete';
export type TypeAncillaries =
  | 'bags'
  | 'seats'
  | 'carryOn'
  | 'extraWeight'
  | 'bagInsurance'
  | 'manageExtras'
  | 'upgrade'
  | null;
